"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seagreen = exports.purple = exports.lightRed = exports.lightYellow = exports.cardWidth = exports.cardWidthValue = exports.indicatorDown = exports.indicatorUp = exports.indicatorUpDown = exports.iconFontFamily = exports.statusIconSize = exports.statusIconSizeValue = exports.orderListHeaderFontSize = exports.columnPickerButtonHeight = exports.checkboxSize = exports.checkboxSizeValue = exports.devBlogArticleMaxWidth = exports.devBlogCardWidth = exports.devBlogSpacing = exports.devBlogMaxWidth = exports.fontWeightBlack = exports.fontWeightExtraBold = exports.fontWeightBold = exports.fontWeightSemiBold = exports.fontWeightNormal = exports.fontWeightLight = exports.fontWeightExtraLight = exports.fontFamilyMuli = exports.grey = exports.lightGray = exports.silver = exports.veryLightGray = exports.negative = exports.neutral = exports.positive = exports.disabled = exports.stateInactive = exports.backgroundWidget = exports.backgroundCard = exports.backgroundSite = exports.darkerGrey = exports.black = exports.white = exports.bosBrand = exports.secondary = exports.primary = exports.helpCenterVideoCardWidth = exports.helpCenterHeaderAndFooterSum = exports.helpCenterFooterHeight = exports.helpCenterFooterHeightValue = exports.appContentNewMaxWidth = exports.appContentMaxWidth = exports.appContentPadding = exports.appGutters = exports.appHeaderHeight = exports.appHeaderHeightValue = exports.appHeadingHeight = exports.buttonBorderRadius = exports.borderRadius = exports.editValueInputWidth = exports.buttonWidth = exports.buttonHeight = exports.anchorTagsHover = exports.anchorTags = void 0;
/**
 * Links
 */
exports.anchorTags = 'a, a:active, a:hover, a:visited';
exports.anchorTagsHover = 'a:active, a:hover';
/**
 * Common variables
 */
exports.buttonHeight = '2rem';
exports.buttonWidth = '7rem';
exports.editValueInputWidth = "calc(50% - #{" + exports.buttonWidth + "} - 1rem)";
exports.borderRadius = '10px';
exports.buttonBorderRadius = '7rem';
exports.appHeadingHeight = '60px';
exports.appHeaderHeightValue = 50;
exports.appHeaderHeight = exports.appHeaderHeightValue + "px";
exports.appGutters = '4em';
exports.appContentPadding = '0.5rem';
exports.appContentMaxWidth = '126rem';
exports.appContentNewMaxWidth = '78.75rem';
exports.helpCenterFooterHeightValue = 144;
exports.helpCenterFooterHeight = exports.helpCenterFooterHeightValue + "px";
exports.helpCenterHeaderAndFooterSum = exports.appHeaderHeightValue + exports.helpCenterFooterHeightValue + "px";
exports.helpCenterVideoCardWidth = '410px';
/**
 * BOS Brand Palette Colours
 *
 * Extracted from https://figma.fun/BHMtbi
 */
exports.primary = '#1bb0a9';
exports.secondary = '#7e72f2';
exports.bosBrand = '#30306f';
exports.white = '#ffffff';
exports.black = '#1c1c1c';
exports.darkerGrey = '#32313c';
exports.backgroundSite = '#f9f9f9';
exports.backgroundCard = '#f3f3f3';
exports.backgroundWidget = '#dfdfdf';
exports.stateInactive = '#c4c4c4';
exports.disabled = '#838383';
exports.positive = '#1bb0a9';
exports.neutral = '#f8cc50';
exports.negative = '#fb1919';
/**
 * Statistic Page Colours
 */
exports.veryLightGray = '#cccccc';
exports.silver = '#c0c0c0';
exports.lightGray = '#e1e1e1';
exports.grey = '#999999';
/**
 * Typography
 */
exports.fontFamilyMuli = 'Mulish, sans-serif';
/**
 * Font weights
 */
exports.fontWeightExtraLight = 200;
exports.fontWeightLight = 300;
exports.fontWeightNormal = 500;
exports.fontWeightSemiBold = 700;
exports.fontWeightBold = 700;
exports.fontWeightExtraBold = 800;
exports.fontWeightBlack = 900;
exports.devBlogMaxWidth = '860px';
exports.devBlogSpacing = '2em';
exports.devBlogCardWidth = '800px';
exports.devBlogArticleMaxWidth = '770px';
/**
 * Checkbox
 */
exports.checkboxSizeValue = 20;
exports.checkboxSize = exports.checkboxSizeValue + "px";
/**
 * Order List
 */
exports.columnPickerButtonHeight = '3rem';
exports.orderListHeaderFontSize = '1rem';
exports.statusIconSizeValue = 22;
exports.statusIconSize = exports.statusIconSizeValue + "px";
/**
 * Icon font
 */
exports.iconFontFamily = 'bos';
exports.indicatorUpDown = '\\e900';
exports.indicatorUp = '\\e901';
exports.indicatorDown = '\\e902';
/**
 * Card
 */
exports.cardWidthValue = 28;
exports.cardWidth = exports.cardWidthValue + "rem";
/**
 * Messagebar
 */
exports.lightYellow = '#f9f0d7';
exports.lightRed = '#F9CCCC';
exports.purple = '#e0def8';
exports.seagreen = '#cceae9';
//# sourceMappingURL=variables.js.map